import { utagLinkCart } from 'features/tealium';

import CartBaseItemView from '../../baseViews/ItemView';
import DeleteCartPromptViewTemplate from '../templates/DeleteCartPromptViewTemplate';

const trackCartEvents = utagLinkCart();
const DeleteCartPromptView = CartBaseItemView.extend({
	JSXTemplate: DeleteCartPromptViewTemplate,

	ui: {
		btnCancel: '.btnCancel',
		btnDelete: '.btnDelete'
	},
	events: {
		'click @ui.btnDelete': 'processDelete',
		'click @ui.btnCancel': 'cancelPrompt'
	},
	templateHelpers () {

		return {
			promptText: this.viewOptions.promptText,
			showInlineError: this.viewOptions.showInlineError
		};

	},
	initialize (options) {

		this.viewOptions = options.viewOptions || {};
		this.modalOptions = options.modalOptions || {};

	},
	onRender () {

		$('body').lpModal(
			$.extend(
				{
					onInit: true,
					width: 400,
					height: 100,
					content: this.$el,
					appendContentToForm: false
				},
				this.modalOptions
			)
		);

	},
	processDelete (e) {

		trackCartEvents({
			eventAction: 'Submit-Employee-Delete'
		});

		const ret = typeof this.viewOptions.onDelete === 'function' ? this.viewOptions.onDelete.call(this, e) : true;

		// cancel closing modal if callback explicitly returned false
		if (ret === false) {

			return false;

		}

		// close modal
		$('#lpModalClose').trigger('click');
		this.remove();
		return true;

	},
	cancelPrompt (e) {

		trackCartEvents({
			eventAction: 'Cancel-Employee-Delete'
		});

		const ret =			typeof this.viewOptions.beforeCancel === 'function' ? this.viewOptions.beforeCancel.call(this, e) : true;

		// cancel closing modal if callback explicitly returned false
		if (ret === false) {

			return false;

		}

		// close modal
		$('#lpModalClose').trigger('click');
		this.remove();
		return true;

	}
});

export default DeleteCartPromptView;
